module.exports = __webpack_public_path__ + "static/media/10-Hampstead.91ee2ab5.mp4";